// DO NOT EDIT -- generated from Go package fs/services/webber/internal/webhooks

///////////
// Enums //
///////////

export enum EventCategory {
	EventCategoryStandard = "standard_event",
	EventCategoryCustom = "custom_event",
	EventCategoryDefined = "defined_event",
	EventCategorySegmentThresholdAlert = "segment_threshold_alert",
	EventCategoryMetricAlert = "metric_alert",
	EventCategoryOperationFinished = "operation_finished"
}


///////////////
// Constants //
///////////////

export const ListSubscriptionsEndpoint: string = "/webhooks/subscriptions";
export const GetEventsEndpoint: string = "/webhooks/events";
export const CreateSubscriptionEndpoint: string = "/webhooks/new";
export const DeleteSubscriptionEndpoint: string = "/webhooks";
export const UpdateSubscriptionEndpoint: string = "/webhooks/update";
export const GetErrorsEndpoint: string = "/webhooks/errors";
export const TestEndpoint: string = "/webhooks/test";

/////////////
// Structs //
/////////////

export interface WebhookEventOption {
  Category: EventCategory;
  Name: string;
  DisplayName: string;
  ExtraInfo: string;
}

export interface WebhookSubscriptionError {
  Cardinality: number;
  ErrorType: string;
  FirstAttempt: number;
  LastAttempt: number;
}

export interface TestEndpointResult {
  Success: boolean;
  Message: string;
}
